/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgZone,
  inject,
  output
} from '@angular/core';
import { Carousel, CarouselStyle } from 'primeng/carousel';
import { PrimeTemplate } from 'primeng/api';
import { MMetricCardComponent } from '../m-metric-card/m-metric-card.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-portfolio-carousel',
  templateUrl: './m-portfolio-carousel.component.html',
  styleUrls: ['./m-portfolio-carousel.component.scss'],
  providers: [CarouselStyle],
  imports: [Carousel, PrimeTemplate, MMetricCardComponent]
})
export class MPortfolioCarouselComponent extends Carousel {
  constructor() {
    const el = inject(ElementRef);
    const zone = inject(NgZone);

    super(el, zone);
  }

  readonly itemClick = output<any>();

  onItemClick(item: any): void {
    if (item?.formattedValue) {
      this.itemClick.emit(item);
    }
  }

  // PrimeNG 20 applies the root class on the host via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper extends Carousel but renders its OWN inner <p-carousel>, so that metadata is inherited
  // onto <m-portfolio-carousel> too — duplicating the carousel root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner carousel is unaffected.
  override cx(): string {
    return '';
  }
}
